import { Skeleton, SkeletonGroup } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { CARD_HEADER_MIN_HEIGHT, MINIMAL_CARD_MIN_HEIGHT } from './quoteCardTypes'

/**
 * Stands in for a card whose indication hasn't been written yet — Rocklake
 * creates its rows inside the submit task, so the page would otherwise read as
 * complete and then grow. Matches the minimal card's geometry so filling in the
 * real carrier moves nothing. `.skeleton-shimmer` lives in css/index.css because a
 * page renders one of these per awaited carrier.
 */
export function QuoteCardSkeleton() {
  return (
    <SkeletonGroup
      aria-label="Waiting for carrier"
      className={cn(
        'bg-card/60 flex w-full flex-col overflow-hidden rounded-xl border px-4 pt-4 pb-3',
        MINIMAL_CARD_MIN_HEIGHT
      )}
    >
      <div className={cn('flex items-center gap-3', CARD_HEADER_MIN_HEIGHT)}>
        <Skeleton className="skeleton-shimmer size-11 shrink-0 animate-none rounded-full" />
        {/* Delayed by its 56px offset in the row so the highlight reads as one band, not two. */}
        <Skeleton className="skeleton-shimmer h-5 w-32 animate-none [animation-delay:0.153s]" />
      </div>
      <div className="flex flex-1 items-center">
        <Skeleton className="skeleton-shimmer h-3 w-full animate-none" />
      </div>
    </SkeletonGroup>
  )
}
